export default __webpack_public_path__ + "static/Support-and-resources-together-mobile-ca9fceefc6bbbd38120df3a19e1b12b7.jpg";